import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from './../../../../components/PageLayout/CheckBox';
import * as PricingPresetDataTypes from '../../../../constants/pricingPresets';
import ApplyToPriceSelect from './../../../../components/StoneSetup/AssignPricing/PricingPresets/ApplyToPriceSelect';
export default function () {
    function onClick1(LINE_LENGTH, ratio) {
        {
            this.setState({ selected: null });
        }
    }
    function onClick2(LINE_LENGTH, ratio, data, dataIndex, price, e) {
        {
            e.preventDefault();
            e.stopPropagation();
            this.setSelected(data);
        }
    }
    function onClick3(LINE_LENGTH, ratio, data, dataIndex, price, e) {
        {
            e.preventDefault();
            e.stopPropagation();
            this.setSelected(data);
        }
    }
    function onClick4(LINE_LENGTH, ratio, data, dataIndex, price, e) {
        {
            e.preventDefault();
            e.stopPropagation();
            this.setSelected(data);
        }
    }
    function onClick5(LINE_LENGTH, ratio, data, dataIndex, price, e) {
        {
            e.preventDefault();
            e.stopPropagation();
            this.setSelected(data);
        }
    }
    function repeatSegment6(LINE_LENGTH, ratio, data, dataIndex, price, segment, segmentIndex) {
        return React.createElement('div', {
            'className': 'algorithm-slab-pricing-circle',
            'style': { left: segment.end * ratio + '%' },
            'key': 'segment_' + segment.start
        });
    }
    function onClick7(LINE_LENGTH, ratio, data, dataIndex, price, e) {
        {
            e.preventDefault();
            e.stopPropagation();
            this.setSelected(data);
        }
    }
    function onClick8(LINE_LENGTH, ratio, data, dataIndex, price, e) {
        {
            e.preventDefault();
            e.stopPropagation();
            this.setSelected(data);
        }
    }
    function onClick9(LINE_LENGTH, ratio, data, dataIndex, price, e) {
        {
            e.preventDefault();
            e.stopPropagation();
            this.setSelected(data);
        }
    }
    function onClick10(LINE_LENGTH, ratio, data, dataIndex, price, e) {
        {
            e.preventDefault();
            e.stopPropagation();
            this.setSelected(data);
        }
    }
    function scopePrice11(LINE_LENGTH, ratio, data, dataIndex) {
        var price = parseFloat(data.value || 0).toFixed(2);
        return [
            data.type == PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG && data === this.state.data[0] ? [React.createElement('div', {
                    'className': 'algorithm-sqft-pricing-line algorithm-sqft-pricing-line--faded',
                    'key': '8231'
                }, React.createElement('div', { 'className': 'algorithm-sqft-pricing-circle-left' }), React.createElement('div', { 'className': 'algorithm-sqft-pricing-arrow' }))] : null,
            data.type == PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG && data !== this.state.data[0] ? [
                data.end === Infinity ? React.createElement('div', {
                    'className': 'algorithm-sqft-pricing-line ' + (this.isSelected(data) ? 'algorithm-selected' : ''),
                    'style': {
                        width: LINE_LENGTH * ratio - data.start * ratio + '%',
                        left: data.start * ratio + '%'
                    },
                    'onClick': onClick2.bind(this, LINE_LENGTH, ratio, data, dataIndex, price),
                    'key': '11871'
                }, React.createElement('div', { 'className': 'algorithm-sqft-pricing-circle-left' }), React.createElement('div', { 'className': 'algorithm-sqft-pricing-arrow' }), React.createElement('div', { 'className': 'algorithm-graph-price' }, this.getPriceElement(price))) : null,
                data.end !== Infinity ? React.createElement('div', {
                    'className': 'algorithm-sqft-pricing-line ' + (this.isSelected(data) ? 'algorithm-selected' : ''),
                    'style': {
                        width: data.end * ratio - data.start * ratio + '%',
                        left: data.start * ratio + '%'
                    },
                    'onClick': onClick3.bind(this, LINE_LENGTH, ratio, data, dataIndex, price),
                    'key': '11873'
                }, React.createElement('div', { 'className': 'algorithm-sqft-pricing-circle-left' }), React.createElement('div', { 'className': 'algorithm-sqft-pricing-circle-right' }), React.createElement('div', { 'className': 'algorithm-graph-price' }, this.getPriceElement(price))) : null
            ] : null,
            data.type == PricingPresetDataTypes.PRICING_PRESET_PLUS_SQFT_SEG ? [React.createElement('div', {
                    'className': 'algorithm-sqft-pricing-to_sqft-line ' + (this.isSelected(data) ? 'algorithm-selected' : ''),
                    'style': {
                        width: (data.end === Infinity ? LINE_LENGTH : data.end) * ratio - data.start * ratio + '%',
                        left: data.start * ratio + '%'
                    },
                    'onClick': onClick4.bind(this, LINE_LENGTH, ratio, data, dataIndex, price),
                    'key': '24711'
                }, data.end !== Infinity ? React.createElement('div', {
                    'className': 'algorithm-sqft-pricing-to_sqft-circle-right',
                    'key': '2918'
                }) : null, data.end === Infinity ? React.createElement('div', {
                    'className': 'algorithm-sqft-pricing-to_sqft-arrow',
                    'key': '3017'
                }) : null, React.createElement('div', { 'className': 'algorithm-graph-price' }, this.getPriceElement(price)))] : null,
            data.type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG ? [React.createElement.apply(this, [
                    'div',
                    {
                        'className': 'algorithm-slab-pricing-line ' + (this.isSelected(data) ? 'algorithm-selected' : ''),
                        'onClick': onClick5.bind(this, LINE_LENGTH, ratio, data, dataIndex, price),
                        'key': '32231'
                    },
                    React.createElement('div', { 'className': 'algorithm-slab-pricing-circle' }),
                    _.map(this.getSlabSegments(data), repeatSegment6.bind(this, LINE_LENGTH, ratio, data, dataIndex, price)),
                    React.createElement('div', { 'className': 'algorithm-slab-pricing-arrow' }),
                    React.createElement('div', { 'className': 'algorithm-graph-price' }, this.getPriceElement(price))
                ])] : null,
            data.type == PricingPresetDataTypes.PRICING_PRESET_PKG_SEG ? [
                data.end !== Infinity ? React.createElement('div', {
                    'className': 'algorithm-pkg-line ' + (this.isSelected(data) ? 'algorithm-selected' : ''),
                    'style': {
                        width: data.end * ratio - data.start * ratio + '%',
                        left: data.start * ratio + '%'
                    },
                    'onClick': onClick7.bind(this, LINE_LENGTH, ratio, data, dataIndex, price),
                    'key': '39711'
                }, React.createElement('div', { 'className': 'algorithm-pkg-circle-left' }), React.createElement('div', { 'className': 'algorithm-pkg-circle-right' }), React.createElement('div', { 'className': 'algorithm-graph-price' }, this.getPriceElement(price))) : null,
                data.end === Infinity ? React.createElement('div', {
                    'className': 'algorithm-pkg-line ' + (this.isSelected(data) ? 'algorithm-selected' : ''),
                    'style': {
                        width: LINE_LENGTH * ratio - data.start * ratio + '%',
                        left: data.start * ratio + '%'
                    },
                    'onClick': onClick8.bind(this, LINE_LENGTH, ratio, data, dataIndex, price),
                    'key': '39713'
                }, React.createElement('div', { 'className': 'algorithm-pkg-circle-left' }), React.createElement('div', { 'className': 'algorithm-pkg-arrow' }), React.createElement('div', { 'className': 'algorithm-graph-price' }, this.getPriceElement(price))) : null
            ] : null,
            data.type == PricingPresetDataTypes.PRICING_PRESET_PLUS_PKG_SEG ? [React.createElement('div', {
                    'className': 'algorithm-pkg-to_sqft-line ' + (this.isSelected(data) ? 'algorithm-selected' : ''),
                    'style': {
                        width: (data.end === Infinity ? LINE_LENGTH : data.end) * ratio - data.start * ratio + '%',
                        left: data.start * ratio + '%'
                    },
                    'onClick': onClick9.bind(this, LINE_LENGTH, ratio, data, dataIndex, price),
                    'key': '51511'
                }, data.end !== Infinity ? React.createElement('div', {
                    'className': 'algorithm-pkg-to_sqft-circle-right',
                    'key': '5588'
                }) : null, data.end === Infinity ? React.createElement('div', {
                    'className': 'algorithm-pkg-to_sqft-arrow',
                    'key': '5682'
                }) : null, React.createElement('div', { 'className': 'algorithm-graph-price' }, this.getPriceElement(price)))] : null,
            data.type == PricingPresetDataTypes.PRICING_PRESET_MIN_SEG ? [React.createElement('div', {
                    'className': 'algorithm-min-line ' + (this.isSelected(data) ? 'algorithm-selected' : ''),
                    'style': { width: data.end * ratio - data.start * ratio + '%' },
                    'onClick': onClick10.bind(this, LINE_LENGTH, ratio, data, dataIndex, price),
                    'key': '58831'
                }, React.createElement('div', { 'className': 'algorithm-min-circle-left' }), React.createElement('div', { 'className': 'algorithm-min-circle-right' }), React.createElement('div', { 'className': 'algorithm-graph-price' }, this.getPriceElement(price)))] : null
        ];
    }
    function repeatData12(LINE_LENGTH, ratio, data, dataIndex, price) {
        return scopePrice11.apply(this, [
            LINE_LENGTH,
            ratio,
            data,
            dataIndex
        ]);
    }
    function repeatPoint13(LINE_LENGTH, ratio, point, pointIndex) {
        return [
            this.state.data[0].type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG ? React.createElement('div', {
                'className': 'algorithm-point-marker',
                'style': { left: 'calc(' + point * ratio + '% + ' + (point > 0 ? '16.5px' : '0px') },
                'key': '64901'
            }, point == 150 ? 'Infinity' : point.toFixed(0)) : null,
            this.state.data[0].type == PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG ? React.createElement('div', {
                'className': 'algorithm-point-marker',
                'style': { left: 'calc(' + point * ratio + '% - ' + (point == 150 ? 35 : point.toFixed(0).toString().length * 6.5) + 'px' },
                'key': '64903'
            }, point == 150 ? 'Infinity' : point.toFixed(0)) : null
        ];
    }
    function onClick14(LINE_LENGTH, ratio) {
        this.addDataSeg(PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG);
    }
    function onClick15(LINE_LENGTH, ratio) {
        this.addDataSeg(PricingPresetDataTypes.PRICING_PRESET_PLUS_SQFT_SEG);
    }
    function onClick16(LINE_LENGTH, ratio) {
        this.addDataSeg(PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG);
    }
    function onClick17(LINE_LENGTH, ratio) {
        this.addDataSeg(PricingPresetDataTypes.PRICING_PRESET_PKG_SEG);
    }
    function onClick18(LINE_LENGTH, ratio) {
        this.addDataSeg(PricingPresetDataTypes.PRICING_PRESET_PLUS_PKG_SEG);
    }
    function onClick19(LINE_LENGTH, ratio) {
        this.addDataSeg(PricingPresetDataTypes.PRICING_PRESET_MIN_SEG);
    }
    function onClick20(LINE_LENGTH, ratio) {
        this.props.toPage(PricingPresetDataTypes.PRICING_PRESET_NEW, this.props.preset);
    }
    function onChange21(LINE_LENGTH, ratio, e) {
        this.setValue('name', e.target.value);
    }
    function onClick22(LINE_LENGTH, ratio, index) {
        this.removeDataSeg(index);
    }
    function onChange23(LINE_LENGTH, ratio, index, minMax, e) {
        this.setSelectedEndValue(e.target.value);
    }
    function onBlur24(LINE_LENGTH, ratio, index, minMax, e) {
        this.enforceMinMax(e, 'end');
    }
    function onChange25(LINE_LENGTH, ratio, index, minMax, e) {
        this.setSelectedStartValue(e.target.value);
    }
    function onBlur26(LINE_LENGTH, ratio, index, minMax, e) {
        this.enforceMinMax(e, 'start');
    }
    function onChange27(LINE_LENGTH, ratio, index, minMax, e) {
        this.setSelectedEndValue(e.target.value);
    }
    function onBlur28(LINE_LENGTH, ratio, index, minMax, e) {
        this.enforceMinMax(e, 'end');
    }
    function onChange29(LINE_LENGTH, ratio, index, minMax) {
        this.updateSelectedValue(index);
    }
    function scopeMinMax30(LINE_LENGTH, ratio, index) {
        var minMax = this.getMinMax(index);
        return React.createElement('div', {
            'className': _.transform({
                'algorithm-properties-inspector': true,
                'algorithm-properties-inspector--slab': this.props.hasSlabModeEnabled && this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG
            }, function (res, value, key) {
                if (value) {
                    res.push(key);
                }
            }, []).join(' '),
            'key': '101505'
        }, React.createElement('div', { 'className': 'algorithm-properties-component' }, index == 0 && this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG ? [React.createElement('div', {
                'className': 'algorithm-circle-inputs',
                'key': '109761'
            }, React.createElement('span', { 'className': 'algorithm-circle-input algorithm-circle-input-start' }, '0'), React.createElement('span', { 'className': 'algorithm-circle-input algorithm-circle-input-end' }, 'Infinity'))] : null, index == 0 && this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG ? [React.createElement('div', {
                'className': 'algorithm-circle-inputs',
                'key': '113541'
            }, React.createElement('input', {
                'type': 'number',
                'className': 'algorithm-circle-input algorithm-circle-input-center algorithm-circle-input-input',
                'value': this.state.selected.end,
                'onChange': onChange23.bind(this, LINE_LENGTH, ratio, index, minMax),
                'onBlur': onBlur24.bind(this, LINE_LENGTH, ratio, index, minMax),
                'min': '1',
                'max': LINE_LENGTH - 1
            }))] : null, index > 0 ? [React.createElement('div', {
                'className': 'algorithm-circle-inputs',
                'key': '119231'
            }, index === this.state.data.length - 1 ? React.createElement('span', {
                'className': 'infinity',
                'onClick': this.setInfinity,
                'title': 'Set End to Infinity',
                'key': '12011'
            }) : null, this.state.selected.type != PricingPresetDataTypes.PRICING_PRESET_MIN_SEG ? React.createElement('input', {
                'type': 'number',
                'className': 'algorithm-circle-input algorithm-circle-input-start algorithm-circle-input-input',
                'value': this.state.selected.start,
                'onChange': onChange25.bind(this, LINE_LENGTH, ratio, index, minMax),
                'onBlur': onBlur26.bind(this, LINE_LENGTH, ratio, index, minMax),
                'min': minMax.start.min,
                'max': minMax.start.end,
                'key': '12152'
            }) : null, this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_MIN_SEG ? React.createElement('span', {
                'className': 'algorithm-circle-input algorithm-circle-input-start',
                'key': '12647'
            }, '0') : null, index < this.state.data.length ? React.createElement('input', {
                'type': this.state.selected.end === Infinity ? 'text' : 'number',
                'className': 'algorithm-circle-input algorithm-circle-input-end algorithm-circle-input-input',
                'value': this.state.selected.end,
                'onChange': onChange27.bind(this, LINE_LENGTH, ratio, index, minMax),
                'onBlur': onBlur28.bind(this, LINE_LENGTH, ratio, index, minMax),
                'min': minMax.end.min,
                'max': index < this.state.data.length ? minMax.end.max : null,
                'key': '12814'
            }) : null)] : null, this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG ? [React.createElement('div', {
                'className': 'algorithm-sqft-pricing-line',
                'style': {
                    width: '50%',
                    left: '25%'
                },
                'key': '133821'
            }, React.createElement('div', { 'className': 'algorithm-sqft-pricing-circle-left' }), this.state.selected.end !== Infinity ? React.createElement('div', {
                'className': 'algorithm-sqft-pricing-circle-right',
                'key': '13629'
            }) : null, this.state.selected.end === Infinity ? React.createElement('div', {
                'className': 'algorithm-sqft-pricing-arrow',
                'key': '13735'
            }) : null)] : null, this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_PLUS_SQFT_SEG ? [React.createElement('div', {
                'className': 'algorithm-sqft-pricing-to_sqft-line',
                'style': {
                    width: '50%',
                    left: '25%'
                },
                'key': '138701'
            }, this.state.selected.end !== Infinity ? React.createElement('div', {
                'className': 'algorithm-sqft-pricing-to_sqft-circle-right',
                'key': '14069'
            }) : null, this.state.selected.end === Infinity ? React.createElement('div', {
                'className': 'algorithm-sqft-pricing-to_sqft-arrow',
                'key': '14184'
            }) : null)] : null, this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG ? [React.createElement('div', {
                'className': 'algorithm-slab-pricing-line',
                'style': {
                    width: '50%',
                    left: '25%'
                },
                'key': '143281'
            }, React.createElement('div', { 'className': 'algorithm-slab-pricing-circle' }), React.createElement('div', {
                'className': 'algorithm-slab-pricing-circle',
                'style': { 'left': 'calc(100% - 17.5px)' }
            }))] : null, this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_PKG_SEG ? [React.createElement('div', {
                'className': 'algorithm-pkg-line',
                'style': {
                    width: '50%',
                    left: '25%'
                },
                'key': '147121'
            }, React.createElement('div', { 'className': 'algorithm-pkg-circle-left' }), this.state.selected.end !== Infinity ? React.createElement('div', {
                'className': 'algorithm-pkg-circle-right',
                'key': '14944'
            }) : null, this.state.selected.end === Infinity ? React.createElement('div', {
                'className': 'algorithm-pkg-arrow',
                'key': '15046'
            }) : null)] : null, this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_PLUS_PKG_SEG ? [React.createElement('div', {
                'className': 'algorithm-pkg-to_sqft-line',
                'style': {
                    width: '50%',
                    left: '25%'
                },
                'key': '151771'
            }, this.state.selected.end !== Infinity ? React.createElement('div', {
                'className': 'algorithm-pkg-to_sqft-circle-right',
                'key': '15366'
            }) : null, this.state.selected.end === Infinity ? React.createElement('div', {
                'className': 'algorithm-pkg-to_sqft-arrow',
                'key': '15476'
            }) : null)] : null, this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_MIN_SEG ? [React.createElement('div', {
                'className': 'algorithm-min-line',
                'style': {
                    width: '50%',
                    left: '25%'
                },
                'key': '156151'
            }, React.createElement('div', { 'className': 'algorithm-min-circle-left' }), React.createElement('div', { 'className': 'algorithm-min-circle-right' }))] : null), React.createElement('div', { 'className': 'algorithm-properties-input-wrapper' }, React.createElement('input', {
            'className': 'algorithm-properties-input',
            'value': (!!this.state.selected.value ? this.getCurrencySymbol() : '') + (this.state.selected.value || ''),
            'placeholder': 'Enter the price for this segment',
            'onChange': onChange29.bind(this, LINE_LENGTH, ratio, index, minMax),
            'ref': node => {
                this.selectedValueInput = node;
            }
        }), index > 0 && this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG ? React.createElement('h1', { 'key': '16322' }, 'Segment Price') : null, index == 0 && this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG ? React.createElement('h1', { 'key': '16449' }, 'Default Price') : null, index == 0 && this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG ? React.createElement('h1', { 'key': '16577' }, 'Slab Price') : null));
    }
    function onChange31(LINE_LENGTH, ratio, index, v) {
        this.updateSelectedSlabSQFTValue(v.target.value);
    }
    function scopeIndex32(LINE_LENGTH, ratio) {
        var index = this.state.selected.index;
        return [
            index > 0 ? React.createElement('div', {
                'className': 'algorithm-properties-delete-button',
                'onClick': onClick22.bind(this, LINE_LENGTH, ratio, index),
                'key': '101501'
            }, React.createElement('div', { 'className': 'algorithm-properties-delete-button-icon' }), React.createElement('h1', {}, 'Delete Segment')) : null,
            index == 0 ? React.createElement('div', {
                'style': {
                    width: '200px',
                    height: '30px'
                },
                'key': '101503'
            }) : null,
            scopeMinMax30.apply(this, [
                LINE_LENGTH,
                ratio,
                index
            ]),
            this.props.hasSlabModeEnabled && this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG ? React.createElement('div', {
                'className': _.transform({
                    'algorithm-properties-inspector': true,
                    'algorithm-properties-inspector--sqft': this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG
                }, function (res, value, key) {
                    if (value) {
                        res.push(key);
                    }
                }, []).join(' '),
                'key': '101507'
            }, React.createElement('div', {
                'className': 'algorithm-sqft-pricing-line',
                'style': {
                    width: '50%',
                    left: '25%'
                }
            }, React.createElement('div', { 'className': 'algorithm-sqft-pricing-circle-left' }), React.createElement('div', { 'className': 'algorithm-sqft-pricing-arrow' })), React.createElement('input', {
                'className': 'algorithm-properties-input',
                'value': (!!this.state.selected.slabSqftValue ? this.getCurrencySymbol() : '') + (this.state.selected.slabSqftValue || ''),
                'placeholder': 'Enter the SQFT price',
                'onChange': onChange31.bind(this, LINE_LENGTH, ratio, index)
            }), React.createElement('h1', {}, 'SQFT Price')) : null
        ];
    }
    function scopeLINE_LENGTHRatio33() {
        var LINE_LENGTH = parseFloat(this.props.LINE_LENGTH);
        var ratio = parseFloat(100) / LINE_LENGTH;
        return React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('div', { 'className': 'assign-popup' }, React.createElement('div', { 'className': 'algorithm-graph-wrapper' }, React.createElement('div', {
            'className': 'algorithm-graph-container',
            'onClick': onClick1.bind(this, LINE_LENGTH, ratio)
        }, React.createElement.apply(this, [
            'div',
            { 'className': 'algorithm-graph-component' },
            _.map(this.state.data, repeatData12.bind(this, LINE_LENGTH, ratio)),
            _.map(this.getUniquePoints(), repeatPoint13.bind(this, LINE_LENGTH, ratio))
        ])), React.createElement('div', { 'className': 'algorithm-graph-tools-wrapper' }, React.createElement('div', {
            'className': 'algorithm-graph-tools algorithm-graph-tools-sqft-pricing ' + (!this.hasRoom() ? 'disabled-muted' : ''),
            'onClick': onClick14.bind(this, LINE_LENGTH, ratio)
        }, React.createElement('h1', {}, 'SQFT Pricing')), React.createElement('div', {
            'className': 'algorithm-graph-tools-short algorithm-graph-tools-sqft-plus-sqft ' + (!this.state.selected || this.state.selected.type !== PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG || !this.hasRoom() || this.state.selected.index == 0 ? 'disabled-muted' : ''),
            'onClick': onClick15.bind(this, LINE_LENGTH, ratio)
        }, React.createElement('h1', {}, 'Plus SQFT')), React.createElement('div', {
            'className': 'algorithm-graph-tools algorithm-graph-tools-slab-size',
            'onClick': onClick16.bind(this, LINE_LENGTH, ratio)
        }, React.createElement('h1', {}, 'Slab Size')), React.createElement('div', {
            'className': 'algorithm-graph-tools algorithm-graph-tools-package-pricing ' + (this.state.data[0].type != PricingPresetDataTypes.PRICING_PRESET_SQFT_SEG || !this.hasRoom() ? 'disabled-muted' : ''),
            'onClick': onClick17.bind(this, LINE_LENGTH, ratio)
        }, React.createElement('h1', {}, 'Package Pricing')), React.createElement('div', {
            'className': 'algorithm-graph-tools-short algorithm-graph-tools-package-plus-sqft ' + (!this.state.selected || this.state.selected.type !== PricingPresetDataTypes.PRICING_PRESET_PKG_SEG || !this.hasRoom() ? 'disabled-muted' : ''),
            'onClick': onClick18.bind(this, LINE_LENGTH, ratio)
        }, React.createElement('h1', {}, 'Plus SQFT')), React.createElement('div', {
            'className': 'algorithm-graph-tools algorithm-graph-tools-Minimum ' + (this.isMinimumDisabled() || !this.hasRoom() ? 'disabled-muted' : ''),
            'onClick': onClick19.bind(this, LINE_LENGTH, ratio)
        }, React.createElement('h1', {}, 'Minimum')))), React.createElement('div', { 'className': 'algorithm-properties-pane' }, React.createElement('div', { 'className': 'algorithm-properties-left-pane' }, React.createElement('div', { 'className': 'algorithm-edit-meta-radio-wrapper' }, React.createElement('div', { 'className': 'algorithm-edit-meta-radio-component' }, React.createElement(ApplyToPriceSelect, {}))), React.createElement('div', {
            'className': 'algorithm-edit-icon-box',
            'onClick': onClick20.bind(this, LINE_LENGTH, ratio)
        }, React.createElement('div', {
            'className': 'algorithm-edit-icon-box-icon',
            'style': { backgroundImage: 'url(' + this.props.preset.icon + ')' }
        }), React.createElement('h1', {}, 'Change Icon')), React.createElement('div', {}, React.createElement('input', {
            'className': 'algorithm-edit-name-input',
            'value': this.state.name,
            'onChange': onChange21.bind(this, LINE_LENGTH, ratio),
            'maxLength': 36
        }))), React.createElement('div', { 'className': 'algorithm-properties-right-pane' }, this.state.selected && (this.state.selected.index > 0 || this.state.selected.type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG) ? scopeIndex32.apply(this, [
            LINE_LENGTH,
            ratio
        ]) : null, !this.state.selected || this.state.selected.index == 0 && this.state.selected.type != PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG ? [React.createElement('h1', { 'key': '175651' }, 'No properties to display')] : null))));
    }
    return scopeLINE_LENGTHRatio33.apply(this, []);
}